"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const styles = __importStar(require("./Search.css"));
const Button_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
const Icon_1 = __importDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
const MainFilters_1 = __importDefault(require("./MainFilters"));
const AdvancedFilters_1 = __importDefault(require("./AdvancedFilters"));
const SearchContextType_1 = require("./SearchContextType");
const constants = __importStar(require("./constants"));
const constants_1 = require("../constants");
const FiltersPanel = (props) => {
    const { config, customFilters, customComponents, showClearAllFilters } = props;
    const [advancedToggled, setAdvanceToggle] = (0, react_1.useState)(false);
    const { search, cancel, clearAndSearch, state } = (0, react_1.useContext)(SearchContextType_1.SearchContext);
    const advancedFiltersOpenClass = `${styles.advancedFiltersButtonOpen} ${constants_1.ANG_CSS_PREFIX}-advanced-filter-button-open`;
    const renderClearAllFilters = showClearAllFilters !== null && showClearAllFilters !== void 0 ? showClearAllFilters : true;
    const handleAdvancedClick = () => setAdvanceToggle(!advancedToggled);
    const handleApply = () => {
        handleAdvancedClick();
        search();
    };
    const handleCancel = () => {
        handleAdvancedClick();
        cancel();
    };
    const handleClear = (e) => {
        e && e.currentTarget && e.currentTarget.blur();
        clearAndSearch();
    };
    function conditionalGroups() {
        let has = false;
        // @ts-ignore
        config[constants.GuiGroups]
            .filter((group) => !group[constants.GuiMain])
            .forEach((group) => {
            const bindings = group[constants.GuiBind] || [];
            bindings.forEach((bind) => {
                const target = bind[constants.GuiTarget];
                const selected = state.filters[target];
                if (bind[constants.GuiValues] &&
                    selected &&
                    selected.length > 0 &&
                    selected.every((a) => bind[constants.GuiValues].includes(a))) {
                    has = true;
                }
            });
        });
        return has;
    }
    const clearFiltersIsDisabled = React.useMemo(() => {
        const filtersValues = Object.values(state.filters || {});
        const customFiltersValues = Object.values(state.customFilters || {})
            .flat()
            .map(({ values }) => values);
        return [...filtersValues, ...customFiltersValues].every(values => values.length === 0);
    }, [state.filters, state.customFilters]);
    const renderClearFiltersButton = () => {
        return (
        // @ts-ignore
        config[constants.GuiGroups].filter((group) => group[constants.GuiProperties].filter((property) => property[constants.GuiVisible] !== undefined ? property[constants.GuiVisible] : true).length > 0).length > 0 && (React.createElement(Button_1.default, { className: `${styles.mainFiltersButton} ${styles.light} ${constants_1.ANG_CSS_PREFIX}-main-filter-button light`, onClick: handleClear, kind: 'tertiary', "data-test-id": 'secondary-filters-footer-cancel', noFill: true, disabled: clearFiltersIsDisabled, "aria-pressed": "false" }, "Clear all filters")));
    };
    const renderAdvancedFiltersButton = () => {
        return (
        // @ts-ignore
        config[constants.GuiGroups]
            .filter((group) => !group[constants.GuiMain])
            .filter((group) => group[constants.GuiProperties].filter((property) => { var _a; return (_a = property[constants.GuiVisible]) !== null && _a !== void 0 ? _a : true; })
            .length > 0).length > 0 && (React.createElement(Button_1.default, { className: `${styles.mainFiltersButton} ${constants_1.ANG_CSS_PREFIX}-main-filter-button ${styles.advancedFiltersButton} ${constants_1.ANG_CSS_PREFIX}-advanced-filter-button ${advancedToggled ? advancedFiltersOpenClass : ''}`, kind: "tertiary", onClick: handleAdvancedClick, "aria-expanded": advancedToggled, "aria-controls": 'secondary-filters', "aria-pressed": advancedToggled, noFill: true, "data-test-id": 'advanced-filters-toggle-button' },
            React.createElement(Icon_1.default, { name: 'filter-small', size: 'xs' }),
            React.createElement("span", null, "Advanced"),
            conditionalGroups() && (React.createElement("span", { "data-test-id": 'advanced-filters-new-icon', className: `${styles.moreFilters} ${constants_1.ANG_CSS_PREFIX}-more-filters`, "aria-live": 'assertive', title: 'More filters are available based on your selections' })))));
    };
    function renderFilters() {
        return (React.createElement("div", { className: `${styles.filtersPanel} ${constants_1.ANG_CSS_PREFIX}-filters-panel`, "data-test-id": 'filters-panel' },
            React.createElement("div", { className: `${styles.mainFiltersPanel} ${constants_1.ANG_CSS_PREFIX}-main-filters-panel`, "data-test-id": 'main-filters-panel' },
                React.createElement(MainFilters_1.default, { config: config, customFilters: customFilters, customComponents: customComponents }),
                React.createElement("div", { className: `${styles.mainFiltersButtons} ${constants_1.ANG_CSS_PREFIX}-main-filters-panel-buttons`, "data-test-id": 'main-filters-buttons' },
                    renderAdvancedFiltersButton(),
                    renderClearAllFilters && renderClearFiltersButton())),
            advancedToggled && (React.createElement(AdvancedFilters_1.default, { config: config, customFilters: customFilters, customComponents: customComponents, handleApply: handleApply, handleCancel: handleCancel, handleClear: handleClear, "data-test-id": 'advanced-filters-container' }))));
    }
    return config[constants.GuiGroups] !== undefined ? renderFilters() : null;
};
exports.default = FiltersPanel;
